import config from "../../../shared/config/config";
import axiosAdmin from "../../../shared/utils/axiosAdmin";
import {
  CodeDto,
  PositionOrRoleDto,
  UpdatePositionOrRoleRequestDto,
} from "../../../types/adminPositionRole";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminPositionRoleApi {
  getPositionList(): Promise<PositionOrRoleDto[]>;
  insertPosition(name: string): Promise<PositionOrRoleDto>;
  updatePosition(
    requestOption: UpdatePositionOrRoleRequestDto
  ): Promise<PositionOrRoleDto>;
  deletePosition(codes: CodeDto[]): Promise<PositionOrRoleDto[]>;

  getRoleList(): Promise<PositionOrRoleDto[]>;
  insertRole(name: string): Promise<PositionOrRoleDto>;
  updateRole(
    requestOption: UpdatePositionOrRoleRequestDto
  ): Promise<PositionOrRoleDto>;
  deleteRole(codes: CodeDto[]): Promise<PositionOrRoleDto[]>;
}

class AdminPositionRoleServerApi implements AdminPositionRoleApi {
  async getPositionList(): Promise<PositionOrRoleDto[]> {
    const resp = await axiosAdmin.get<PositionOrRoleDto[]>(
      `${GATEWAY_URL}/wapi/admins/positions`
    );

    return Promise.resolve(resp.data);
  }
  async insertPosition(name: string): Promise<PositionOrRoleDto> {
    const resp = await axiosAdmin.post<PositionOrRoleDto>(
      `${GATEWAY_URL}/wapi/admins/positions/insert`,
      {
        name: name,
      }
    );

    return Promise.resolve(resp.data);
  }
  async updatePosition(
    requestOption: UpdatePositionOrRoleRequestDto
  ): Promise<PositionOrRoleDto> {
    const resp = await axiosAdmin.post<PositionOrRoleDto>(
      `${GATEWAY_URL}/wapi/admins/positions/update`,
      requestOption
    );

    return Promise.resolve(resp.data);
  }
  async deletePosition(codes: CodeDto[]): Promise<PositionOrRoleDto[]> {
    const resp = await axiosAdmin.post<PositionOrRoleDto[]>(
      `${GATEWAY_URL}/wapi/admins/positions/delete`,
      codes
    );

    return Promise.resolve(resp.data);
  }

  async getRoleList(): Promise<PositionOrRoleDto[]> {
    const resp = await axiosAdmin.get<PositionOrRoleDto[]>(
      `${GATEWAY_URL}/wapi/admins/roles`
    );

    return Promise.resolve(resp.data);
  }
  async insertRole(name: string): Promise<PositionOrRoleDto> {
    const resp = await axiosAdmin.post<PositionOrRoleDto>(
      `${GATEWAY_URL}/wapi/admins/roles/insert`,
      {
        name: name,
      }
    );

    return Promise.resolve(resp.data);
  }
  async updateRole(
    requestOption: UpdatePositionOrRoleRequestDto
  ): Promise<PositionOrRoleDto> {
    const resp = await axiosAdmin.post<PositionOrRoleDto>(
      `${GATEWAY_URL}/wapi/admins/roles/update`,
      requestOption
    );

    return Promise.resolve(resp.data);
  }
  async deleteRole(codes: CodeDto[]): Promise<PositionOrRoleDto[]> {
    const resp = await axiosAdmin.post<PositionOrRoleDto[]>(
      `${GATEWAY_URL}/wapi/admins/roles/delete`,
      codes
    );

    return Promise.resolve(resp.data);
  }
}
const adminPositionRoleApi: AdminPositionRoleApi =
  new AdminPositionRoleServerApi();
export default adminPositionRoleApi;
